import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { ErrorMsg } from '../components/ui';
import { api, errorText } from '../lib/api';
import { useSession } from '../lib/session';
import type { User } from '../lib/types';

export function Login() {
  const { user, setUser } = useSession();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const next = params.get('next');
  const target = next && next.startsWith('/') && !next.startsWith('//') ? next : '/';

  if (user) return <Navigate to={target} replace />;

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const u = await api<User>('/api/auth/login', { method: 'POST', body: { email, password }, noRedirect: true });
      setUser(u);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login" onSubmit={submit} aria-label="Sign in">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true" />
          <span className="brand-name">
            Mirage <em>Marketing</em>
          </span>
        </div>
        <h1>Sign in</h1>
        <p className="muted">Internal tool of Mirage Visualisation, Sofia.</p>
        <label className="field">
          <span>Email</span>
          <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </label>
        <label className="field">
          <span>Password</span>
          <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <ErrorMsg>{error}</ErrorMsg>
        <button className="btn primary block" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
